import { makeStyles, Theme } from "@material-ui/core";

import { CORE_CARD_STYLES } from "../UnlockCodeCard/styles";

interface IStyleProps {
  cardBorderLeftColor: string;
}

const useStyles = makeStyles<Theme, IStyleProps>(
  _theme => ({
    collapsedCardContainer: {
      ...CORE_CARD_STYLES,
      alignItems: "center",
      display: "flex",
      fontSize: 18,
      height: "60px",
      justifyContent: "space-between",
      padding: "12px 24px",
      borderLeft: ({ cardBorderLeftColor }) =>
        `10px solid ${cardBorderLeftColor}`
    },
    collapsedCardErrorContainer: {
      color: "#EC5D77",
      alignItems: "center",
      display: "flex",
      gap: "8px"
    },
    expandArrowContainer: {
      "& path": {
        fill: "#0030FF"
      },
      "& > span": {
        position: "relative",
        right: 8,
        top: 4,
        fill: "#0030FF"
      },
      "& > span > svg": {
        transform: "rotate(90deg)"
      }
    }
  }),
  {
    name: "CollapsedCard"
  }
);

export default useStyles;
